'use client'

import { useEffect } from 'react'

import { persistor } from '@/libs/store'

const CleanUpAllState = () => {
  useEffect(() => {
    persistor.purge()
  }, [])

  return null
}

export default CleanUpAllState
